
<template>
  <div>
    <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-row>
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
        </v-row>
        <br>

         <!-- icon data -->
            <v-card elevation="7">
              <v-card-text>
                <div class="text-center">
                  <v-row class="mb-6" justify="center" no-gutters>
                      <v-col cols="3">
                      <v-icon color="#7E57C2" size="50" @click="exportEmpInfo()"
                        >mdi-account-check</v-icon
                      ><br />
                      ข้อมูลพนักงาน
                      <br />
                      <v-alert dark dense border="left" type="success" color="#7E57C2" @click="exportEmpInfo()">
                        Export Data
                      </v-alert>
                    </v-col>
                    <v-col cols="1">
                      <v-divider vertical></v-divider>
                    </v-col>
                    <v-col cols="3">
                      <v-icon color="#5C6BC0" size="50" @click="exportEmpFamily()"
                        >mdi-account-group</v-icon
                      ><br />
                      ครอบครัวพนักงาน
                      <br />
                      <v-alert dense border="left" color="#5C6BC0" type="success" @click="exportEmpFamily()">
                        Export Data
                      </v-alert>
                    </v-col>
                    <v-col cols="1">
                      <v-divider vertical></v-divider>
                    </v-col>
                    <v-col cols="3">
                      <v-icon color="#42A5F5" size="50" @click="exportEmpAddress()"
                        > mdi-bank-check</v-icon
                      ><br />
                      ที่อยู่พนักงาน
                      <br />
                      <v-alert dense border="left" type="success" color="#42A5F5" @click="exportEmpAddress()">
                        Export Data
                      </v-alert>
                    </v-col>
                  </v-row>
                    <v-row class="mb-6" justify="center" no-gutters>
                      <v-col cols="3">
                      <v-icon color="#4DB6AC" size="50" @click="exportComputerSkill()"
                        > mdi-monitor-dashboard </v-icon
                      ><br />
                      ทักษะด้านคอมพิวเตอร์
                      <br />
                      <v-alert dark dense border="left" type="success" color="#4DB6AC" @click="exportComputerSkill()">
                        Export Data
                      </v-alert>
                    </v-col>
                    <v-col cols="1">
                      <v-divider vertical></v-divider>
                    </v-col>
                    <v-col cols="3">
                      <v-icon color="#66BB6A" size="50" @click="exportLanguageSkill()"
                        > mdi-google-translate </v-icon
                      ><br />
                      ทักษะภาษา
                      <br />
                      <v-alert dense border="left" color="#66BB6A" type="success" @click="exportLanguageSkill()">
                        Export Data
                      </v-alert>
                    </v-col>
                    <v-col cols="1">
                      <v-divider vertical></v-divider>
                    </v-col>
                    <v-col cols="3">
                      <v-icon color="#9CCC65" size="50" @click="exportHealth()"
                        > mdi-hospital-box-outline</v-icon
                      ><br />
                      ประกันสุขภาพ
                      <br />
                      <v-alert dense border="left" color="#9CCC65" type="success" @click="exportHealth()">
                        Export Data
                      </v-alert>
                    </v-col>
                  </v-row>
                </div>
              </v-card-text>
            </v-card>
          <!-- END icon data -->
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../../Sidebar.vue' // เมนู
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
import Index from '../../UploadExcel/index.vue'
import moment from 'moment'

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile,
    Index
  },
  created () {},
  data () {
    return {
      date: new Date().toISOString().substr(0, 10),
      session: this.$session.getAll(),
      dataItem: [],
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'ดาวน์โหลด ไฟล์ ข้อมูล พนักงาน',
          disabled: true,
          href: '/HRM/Employee/Export'
        }
      ]
    }
  },
  async mounted () {
  },
  methods: {
    exportEmpInfo () {
      this.dataItem = []
      axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/employee/get",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataItem = response.data
          var tem = []
          response.data.forEach(element => {
            let s = {
              'รหัสพนักงาน': element.empCode,
              'รหัสพนักงานเก่า': element.empCodeOld,
              'รหัสตำแหน่ง': element.positionCode,
              'คำนำหน้าชื่อไทย': element.empTitle_NameTH,
              'ขื่อไทย': element.empFirst_NameTH,
              'นามสกุลไทย': element.empLast_NameTH,
              'ขื่อ-นามสกุลไทย': element.empFull_NameTH,
              'คำนำหน้าชื่ออังกฤษ': element.empTitle_NameEN,
              'ชื่อภาษาอังกฤษ': element.empFirst_NameEN,
              'นามสกุลอังกฤษ': element.empLast_NameEN,
              'ชื่อ-นามสกุลอังกฤษ': element.empFull_NameEN,
              'ชื่อเล่น': element.empNickname,
              'วันเกิด': element.empBirthday,
              'อายุ': element.AGE,
              'เพศ': element.empGender,
              'เบอร์ติดต่อ': element.empTel,
              'รหัสบัตรประชาชน': element.empIDCard,
              'Facebook': element.empFacebook,
              'LINE ID': element.empLineID,
              'เบอร์ฉุกเฉิน': element.empEmergencyCall,
              'เลขใบขับขี่': element.empDriverLicense,
              'ประเภทใบขับขี่': element.empDriverLicenseType,
              'งานอดิเรก': element.hobby,
              'วันทำบัตรประชาชน': element.issuedDate,
              'วันหมดอายุบัตรประชาชน': element.expireDate,
              'สถานที่ทำบัตรประชาชน': element.issuedAt,
              'จังหวัดที่ทำบัตรประชาชน': element.issuedProvince,
              'รับรองทางทหาร': element.masMilitaryStatusCode,
              'ตำแหน่งงาน': element.positionName,
              'ประเภทตำแหน่งงาน': element.positionTypeName,
              'แผนก': element.masDepartmentName,
              'สาขา': element.masBranchName,
              'บริษัท': element.masCompanyName,
              'ความสามารถพิเศษอื่นๆ': element.empGenius,
              'วันที่เริ่มทำงาน': element.startDate
            }
            tem.push(s)
          })
          console.log(tem)
          var info = XLSX.utils.json_to_sheet(tem)
          var wb = XLSX.utils.book_new() // make Workbook of Excel
          XLSX.utils.book_append_sheet(wb, info, 'worksheet') // sheetAName is name of Worksheet
          var month = this.getMonthTh()
          let date = new Date()
          var year = moment().format('YYYY')
          var day = date.getDate()

          XLSX.writeFile(wb, 'ช้อมูลพนักงาน (' + day + ' ' + month + ' ' + year + ').xls') // name of the file is 'book.xlsx'
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    exportEmpFamily () {
      this.dataItem = []
      axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/employee_family/get",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataItem = response.data
          var tem = []
          response.data.forEach(element => {
            let s = {
              'รหัสพนักงาน': element.empCode,
              'ขื่อ-นามสกุลไทย': element.empFull_NameTH,
              'แผนก': element.masDepartmentName,
              'สาขา': element.masBranchName,
              'บริษัท': element.masCompanyName,
              'ความสัมพันธ์': element.familyStatus,
              'คำนำหน้า': element.familyTitleName,
              'ชื่อ': element.familyFirstName,
              'นามสกุล': element.familyLastName,
              'อาชีพ': element.familyCareer,
              'ที่อยู่/สถานที่ทำงาน': element.familyAddress,
              'เบอร์โทรศัพท์': element.familyTel,
              'เป็นผู้ติดต่อกรณีฉุกเฉิน': element.emergencyStatus,
              'อยู่กับครอบครัว': element.familyStayWithFamStatus
            }
            tem.push(s)
          })
          console.log(tem)
          var info = XLSX.utils.json_to_sheet(tem)
          var wb = XLSX.utils.book_new() // make Workbook of Excel
          XLSX.utils.book_append_sheet(wb, info, 'worksheet') // sheetAName is name of Worksheet
          var month = this.getMonthTh()
          let date = new Date()
          var year = moment().format('YYYY')
          var day = date.getDate()

          XLSX.writeFile(wb, 'ช้อมูลครอบครัวพนักงาน (' + day + ' ' + month + ' ' + year + ').xls') // name of the file is 'book.xlsx'
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    exportEmpAddress () {
      this.dataItem = []
      axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/employee_address/get",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataItem = response.data
          var tem = []
          response.data.forEach(element => {
            let s = {
              'รหัสพนักงาน': element.empCode,
              'ขื่อ-นามสกุลไทย': element.empFull_NameTH,
              'ที่อยู่': element.empAddressName,
              'รหัสไปรษณี': element.empAddressZipcode,
              'จังหวัด': element.empAddressProvine,
              'อำเภอ': element.empAddressDistrict,
              'ตำบล': element.empAddressSubDistrict,
              'ประเภทที่อยู่': element.empAddressStatus
            }
            tem.push(s)
          })
          console.log(tem)
          var info = XLSX.utils.json_to_sheet(tem)
          var wb = XLSX.utils.book_new() // make Workbook of Excel
          XLSX.utils.book_append_sheet(wb, info, 'worksheet') // sheetAName is name of Worksheet
          var month = this.getMonthTh()
          let date = new Date()
          var year = moment().format('YYYY')
          var day = date.getDate()

          XLSX.writeFile(wb, 'ช้อมูลที่อยู่พนักงาน (' + day + ' ' + month + ' ' + year + ').xls') // name of the file is 'book.xlsx'
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    exportComputerSkill () {
      this.dataItem = []
      axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/employee_computer_skill/get",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataItem = response.data
          var tem = []
          response.data.forEach(element => {
            let s = {
              'รหัสพนักงาน': element.empCode,
              'ขื่อ-นามสกุลไทย': element.empFull_NameTH,
              'แผนก': element.masDepartmentName,
              'สาขา': element.masBranchName,
              'บริษัท': element.masCompanyName,
              'ทักษะภาษา': element.languageCode,
              'การอ่าน': element.empLanguageRead,
              'การพูด': element.empLanguageSpeak,
              'การเขียน': element.empLanguageWrite
            }
            tem.push(s)
          })
          console.log(tem)
          var info = XLSX.utils.json_to_sheet(tem)
          var wb = XLSX.utils.book_new() // make Workbook of Excel
          XLSX.utils.book_append_sheet(wb, info, 'worksheet') // sheetAName is name of Worksheet
          var month = this.getMonthTh()
          let date = new Date()
          var year = moment().format('YYYY')
          var day = date.getDate()

          XLSX.writeFile(wb, 'ช้อมูลทักษะคอมพิวเตอร์พนักงาน (' + day + ' ' + month + ' ' + year + ').xls') // name of the file is 'book.xlsx'
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    exportLanguageSkill () {
      this.dataItem = []
      axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/employee_language_skill/get",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataItem = response.data
          var tem = []
          response.data.forEach(element => {
            let s = {
              'รหัสพนักงาน': element.empCode,
              'ขื่อ-นามสกุลไทย': element.empFull_NameTH,
              'แผนก': element.masDepartmentName,
              'สาขา': element.masBranchName,
              'บริษัท': element.masCompanyName,
              'ทักษะภาษา': element.languageCode,
              'การอ่าน': element.empLanguageRead,
              'การพูด': element.empLanguageSpeak,
              'การเขียน': element.empLanguageWrite
            }
            tem.push(s)
          })
          console.log(tem)
          var info = XLSX.utils.json_to_sheet(tem)
          var wb = XLSX.utils.book_new() // make Workbook of Excel
          XLSX.utils.book_append_sheet(wb, info, 'worksheet') // sheetAName is name of Worksheet
          var month = this.getMonthTh()
          let date = new Date()
          var year = moment().format('YYYY')
          var day = date.getDate()

          XLSX.writeFile(wb, 'ช้อมูลทักษะภาษาพนักงาน (' + day + ' ' + month + ' ' + year + ').xls') // name of the file is 'book.xlsx'
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    exportHealth () {
      this.dataItem = []
      axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/employee_health/get",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataItem = response.data
          var tem = []
          response.data.forEach(element => {
            let s = {
              'รหัสพนักงาน': element.empCode,
              'ขื่อ-นามสกุลไทย': element.empFull_NameTH,
              'แผนก': element.masDepartmentName,
              'สาขา': element.masBranchName,
              'บริษัท': element.masCompanyName,
              'อีเมล': element.empEmail,
              'เพศ': element.empGender,
              'เบอร์ติดต่อ': element.empTel,
              'รหัสบัตรประชาชน': element.empIDCard,
              'บริษัท ประกัน': element.empHealthName,
              'กรมธรรม์เลขที่': element.healthGroupNumber,
              'วันที่ แจ้งเข้า': element.healthGroupStartDate,
              'เข้าระบบ / ต่ออายุ': element.healthGroupRenew,
              'วันที่ เริ่มคุ้มครอง': element.healthGroupStart,
              'วันที่ สิ้นสุด คุ้มครอง': element.healthGroupEnd,
              'สถานพยาบาล': element.healthAddress,
              'เบอร์โทรศัพท์': element.healthTel,
              'เลขที่รับแจ้ง': element.healthNumber,
              'วันที่เริ่มใช้สิทธิ์': element.healthStartDate,
              'วันที่หมดอายุ': element.healthExpireDate
            }
            tem.push(s)
          })
          console.log(tem)
          var info = XLSX.utils.json_to_sheet(tem)
          var wb = XLSX.utils.book_new() // make Workbook of Excel
          XLSX.utils.book_append_sheet(wb, info, 'worksheet') // sheetAName is name of Worksheet
          var month = this.getMonthTh()
          let date = new Date()
          var year = moment().format('YYYY')
          var day = date.getDate()

          XLSX.writeFile(wb, 'ช้อมูลประกันสังคม พนักงาน (' + day + ' ' + month + ' ' + year + ').xls') // name of the file is 'book.xlsx'
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    }

  }
}
</script>
<style scope>
.scroll {
  overflow-y: scroll;
}
.header_1 {
  font-family: Kanit;
  font-size: 20px;
  display: flex;
  color: #871b12;
}
</style>



// WEBPACK FOOTER //
// src/components/HRM/Employee/Export.vue